import { Drawer, Fade } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import MenuOption from "../../components/MenuOption/MenuOption";
import MenuOptions from "../../components/MenuOptions/MenuOptions";
import useKeyboardShortcuts from "../../hooks/useKeyboardShortcuts";
import { items } from "../../utils/Items";
import { State, Type } from "../DrawerMain/DrawerMain";
import { useTranslation } from "../../hooks/useTranslation";
import { useStyles } from "./DrawerDesktopStyle";

type DrawerDesktopProps = {
  menuState: State;
  menuAction: (type: Type) => void;
};

export const DrawerDesktop = ({
                                  menuState,
                                  menuAction,
                              }: DrawerDesktopProps) => {
    useKeyboardShortcuts();
    const classes = useStyles();
    const { t } = useTranslation();
    const handleLeaveDrawer = () => {
        menuAction(Type.LEAVE_DRAWER);
    };
    const handleEnterDrawer = () => {
        menuAction(Type.ON_DRAWER);
    };

    return (
        <>
            <Drawer
                onMouseLeave={handleLeaveDrawer}
                onMouseEnter={handleEnterDrawer}
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: menuState.open,
                    [classes.drawerClose]: !menuState.open,
                })}
                classes={{
                    paper: clsx(classes.paper, {
                        [classes.drawerOpen]: menuState.open,
                        [classes.drawerClose]: !menuState.open,
                    }),
                }}
            >
                <div className={classes.buttonContainer}>
                    {items.map((item, index) => (
                        <MenuOption
                            key={index}
                            route={item.href}
                            text={t(item.bundleTitle)}
                            keys={item.keys}
                            iconUrl={item.src}
                            open={menuState.open}
                            showBadge={item.showBadge}
                        />
                    ))}
                </div>
                <Fade in={menuState.open}>
                    <div className={classes.optionsStyle}>
                        <MenuOptions />
                    </div>
                </Fade>
            </Drawer>
        </>
    );
};

